angular.module('eCareVault.common.formTemplate', []);
